module.exports = __webpack_public_path__ + "static/media/new-icon.8029cffc.svg";